export default __webpack_public_path__ + "static/generative-border-dark-069ec5c49d1b552c7f61e1e33ff83f4bf81ac12fd56adcdf978710c88c6af584.mp4";